import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['toggleable', 'button'];
    static values = { open: Boolean };

    initialize() {
        this.isConnected = false;
        this.toggleClass = 'hidden';
        this.openText = 'Öppna meny';
    }

    connect() {
        document.body.addEventListener('keydown', this._onBodyKeydown);

        this.buttonTargets.forEach((target) => {
            target.setAttribute('aria-expanded', 'false');
            target.setAttribute('aria-controls', 'mobile-menu');
            target.querySelector('.js-text-content').textContent = this.openText;
        });

        this.isConnected = true;
    }

    toggle(event) {
        event.preventDefault();
        this.openValue = !this.openValue;
    }

    _onBodyKeydown = (event) => {
        if (event.key === 'Escape') {
            this.openValue = false;
        }
    };

    openValueChanged() {
        if (!this.isConnected) { return }

        if (!this.toggleClass) { return }

        this.buttonTargets.forEach((target) => {
            target.setAttribute('aria-expanded', this.openValue);
            target.setAttribute('aria-label', this.openValue ? 'Stäng meny' : this.openText);

            // Hamburger graphics
            target.querySelector('.js-content-expanded').classList.toggle(this.toggleClass);
            target.querySelector('.js-content-collapsed').classList.toggle(this.toggleClass);

            document.body.classList.toggle('overflow-hidden');
            
            this.className = this.openValue
                ? 'bg-white shadow-sm lg:static lg:overflow-y-visible fixed inset-0 z-40 overflow-y-auto'
                    : 'bg-white shadow-sm lg:static lg:overflow-y-visible';
        });

        this.toggleableTargets.forEach((target) => {
            target.classList.toggle(this.toggleClass);
        });
    }
}
